import { config } from '../../config';
import { HttpServices } from '../../Helper';

const leadXchange = HttpServices.create();

leadXchange.interceptors.request.use(
  (configuration) => {
    configuration.headers.ApiKey = config.apiKey;

    return configuration;
  },
  (error) => Promise.reject(error)
);
const baseURL = `${config.leadxchange_server_address}/LeadXchangePool`;

export const GetAllEntityCommissionSettings = async () => {
  const result = await leadXchange.get(
    `${baseURL}/LeadExchangePoolConfigration/GetAllEntityCommissionSettings`
  );
  return result.data;
};

export const GetAllEntitySources = async () => {
  const result = await leadXchange.get(
    `${baseURL}/LeadExchangePoolConfigration/GetAllEntitySources`
  );
  return result.data;
};

export const CreateEntityCommissionSetting = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/LeadExchangePoolConfigration/CreateEntityCommissionSetting`,
    body
  );
  return result.data;
};

export const UpdateEntityCommissionSetting = async (body) => {
  const { entityCommissionSettingId: id, ...rest } = body;
  const result = await leadXchange.put(
    `${baseURL}/LeadExchangePoolConfigration/UpdateEntityCommissionSetting/${id}`,
    rest
  );
  return result.data;
};
export const DeleteEntityCommissionSetting = async (id) => {
  const result = await leadXchange.delete(
    `${baseURL}/LeadExchangePoolConfigration/DeleteEntityCommissionSetting/${id}`
  );
  return result.data;
};
export const GetAllLeadExchangePoolConfiguration = async () => {
  const result = await leadXchange.get(
    `${baseURL}/LeadExchangePoolConfigration/GetAllLeadExchangePoolConfiguration`
  );
  return result.data;
};
export const UpdateLeadExchangePoolConfiguration = async (body) => {
  const { leadExchangeGlobalConfigurationId: id, ...rest } = body;
  const result = await leadXchange.put(
    `${baseURL}/LeadExchangePoolConfigration/UpdateLeadExchangePoolConfiguration/${id}`,
    rest
  );
  return result.data;
};
export const GetAllSlaConfiguration = async () => {
  const result = await leadXchange.get(
    `${baseURL}/LeadExchangePoolConfigration/GetAllSlaConfiguration`
  );
  return result.data;
};
export const UpsertSlaConfiguration = async (body) => {
  const result = await leadXchange.put(
    `${baseURL}/LeadExchangePoolConfigration/UpsertSlaConfiguration`,
    body
  );
  return result.data;
};
export const GetAllLeadExchangePoolCampaigns = async (name) => {
  const result = await leadXchange.get(
    `${baseURL}/LeadExchangePoolConfigration/GetAllLeadExchangePoolCampaigns?name=${name}`
  );
  return result.data;
};
export const GetAllCampaignOverrides = async () => {
  const result = await leadXchange.get(
    `${baseURL}/CampaignCommission/GetAllCampaignOverrides`
  );
  return result.data;
};

export const CreateCampaignCommissionOverride = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/CampaignCommission/CreateCampaignCommissionOverride`,
    body
  );
  return result.data;
};
export const UpdateCampaignCommissionOverride = async (body) => {
  const { campaignCommissionOverrideId: id, ...rest } = body;
  const result = await leadXchange.put(
    `${baseURL}/CampaignCommission/UpdateCampaignCommissionOverride/${id}`,
    rest
  );
  return result.data;
};
export const DeleteCampaignCommissionOverride = async (id) => {
  const result = await leadXchange.delete(
    `${baseURL}/CampaignCommission/DeleteCampaignCommissionOverride/${id}`
  );
  return result.data;
};
export const LeadXchangeGetAllSharedLeads = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/SharedLead/GetAllSharedLeads`,
    body
  );
  return result.data;
};
export const LeadXchangeClaimLead = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/SharedLead/ClaimLead`,
    body
  );
  const data = result.data[0];

  if (!data.success) {
    console.log('data.success: ', data.success);
    throw new Error(data.message || 'Claim lead failed');
  }

  return data;
};
export const BulkLeadsAutoRotationAsync = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/SharedLead/BulkLeadsAutoRotationAsync`,
    body
  );
  return result.data;
};
export const GetAllSharedRotationScheme = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/SharedLead/GetAllSharedRotationScheme`,
    body
  );
  return result.data;
};
export const GetAllUserSearchForShareLeads = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/SharedLead/GetAllUserSearchForShareLeads`,
    body
  );
  return result.data;
};
export const ReassignLeadsAsync = async (body) => {
  const result = await leadXchange.post(
    `${baseURL}/SharedLead/ReassignLeadsAsync`,
    body
  );
  return result.data;
};
export const GetDashboardSummary = async (params = {}) => {
  const { startDate, endDate } = params;
  const result = await leadXchange.get(
    `${baseURL}/SharedLead/GetDashboardSummary`,
    {
      params: {
        startDate,
        endDate,
      },
    }
  );
  return result.data;
};
